// Stage Mail-1:パスワード入力欄コンポーネント。
//
// 仕様(design §3.7):
// - type="password"(ブラウザの autofill を遮断)
// - autoComplete="off"
// - 任意:表示 / 非表示 切替(アイコンボタン)
// - 任意:hint(例:「保存後は表示されません」)
//
// Mail-1 ではパスワード「送信すると Fernet で暗号化して保存」するので、
// 画面入力中にブラー時の警告も出さない。一度保存したら同じフィールドには
// 表示しない(DB row の password_encrypted は渡ってこない)。

import React, { useState } from "react";
import { Eye, EyeOff, ShieldCheck } from "lucide-react";

export interface SecretFieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  /** field の補足。例:「保存後は表示されません」 */
  hint?: string;
  /** 必須表示(左に赤いアスタリスク) */
  required?: boolean;
  /** 入力を無効化 */
  disabled?: boolean;
  /** 任意の ID。label の for 属性に連動。 */
  id?: string;
}

export function SecretField({
  label,
  value,
  onChange,
  placeholder,
  hint,
  required = false,
  disabled = false,
  id,
}: SecretFieldProps) {
  const [visible, setVisible] = useState(false);
  const inputId = id ?? `secret-field-${label.replace(/\s+/g, "-").toLowerCase()}`;
  return (
    <div className="field">
      <label className="field-label" htmlFor={inputId}>
        {label}
        {required && <span style={{ color: "#dc2626" }}> *</span>}
      </label>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <input
          id={inputId}
          className="input"
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete="off"
          // 1Password / Bitwarden の autofill をブロックするヒント:
          // (Mail-1 では autoComplete=off のみ)
          // Mail-1 の仕様では user の手入力 / 貼り付けのみ受け付ける
          data-1p-ignore
          data-bwignore
          spellCheck={false}
          style={{ flex: 1 }}
        />
        <button
          type="button"
          onClick={() => setVisible(!visible)}
          disabled={disabled}
          aria-label={visible ? "パスワードを隠す" : "パスワードを表示"}
          style={{
            padding: "6px 8px",
            border: "1px solid #e5e7eb",
            background: "#ffffff",
            borderRadius: 6,
            cursor: disabled ? "default" : "pointer",
            color: "#6b7280",
          }}
        >
          {visible ? <EyeOff size={14} /> : <Eye size={14} />}
        </button>
      </div>
      {hint && (
        <span className="field-hint">
          <ShieldCheck size={11} style={{ verticalAlign: "middle", marginRight: 4 }} />
          {hint}
        </span>
      )}
    </div>
  );
}
